import { useEffect, useState, useContext, useMemo } from "react";
import { Typography, Box, Backdrop, CircularProgress, TextField, MenuItem, Button, Paper, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Header from "../Components/layout/Header";
import { API } from "../conf";
import { Context } from "../App";
import success_gif from '../asset/pictures/Successfully Done.gif';
import { useNavigate } from "react-router-dom";

export default function Cloture() {
    const navigate = useNavigate()
    const { updateConnect, exercice, exercices } = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"]
    const [loading, setLoad] = useState(true)
    const [result, setResult] = useState()
    const [uncloture_months, setUncloture_months] = useState([])
    const [month, setMonth] = useState('')
    const [dons, setDons] = useState([])
    const [versements, setVersements] = useState([])
    const [depenses, setDepenses] = useState([])
    const [alerts, setAlerts] = useState([])
    const [isBudgetComplete, setBudgetComplete] = useState(true)
    const [cloturesByYear, setCloturesByYear] = useState({})

    const eglise = useMemo(()=>{
        if (organisation && organisation.type==='église') {
            return organisation
        } else if (egliseId!=='') {
            return eglises.find(el=> el._id === egliseId)
        } else return
    }, [eglises, egliseId, organisation])

    function handleSubmit() {
        setLoad(true)
        fetch(API.concat(`/eglises/${eglise.number}/cloture/${month}?exercice=${exercice}`), {
            method:'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    setResult(<img src={success_gif} alt="succès" loading="eager" width={500} height={500}/>)
                    setTimeout(() => {
                        navigate("/")
                    }, 3000);
                }
            }
        })
    }

    function reset() {
        setUncloture_months([])
        setMonth('')
        setDons([])
        setVersements([])
        setDepenses([])
        setAlerts([])
        setBudgetComplete(true)
    }

    function get_uncloture(month) {
        setLoad(true)
        fetch(API.concat(`/eglises/${eglise.number}/cloture/${exercice}/${month+1}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const {dons, depenses, versements} = await response.json()
                    setDons(dons)
                    setDepenses(depenses)
                    setVersements(versements)
                }setLoad(false)
            }
        })
    }

    useEffect(()=>{
        if(eglise&&eglise.number) {
            const headers = { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token') }

            fetch(API.concat(`/alerts/${JSON.stringify({eglises: eglise.number, is_active: true, exercice})}`), { method: 'GET', headers })
                .then(async response => {
                    const token = response.headers.get('x-auth-token')
                    if (response.status === 401) { sessionStorage.clear(); updateConnect(false) }
                    else {
                        if (token && token !== sessionStorage.getItem('token') && token !== '') sessionStorage.setItem('token', token)
                        if (response.status === 200) setAlerts(await response.json())
                    }
                })

            const compteQuery = new URLSearchParams({eglise: eglise.number, exercice}).toString()
            fetch(API.concat(`/comptes/by?${compteQuery}`), { method: 'GET', headers })
                .then(async response => {
                    const token = response.headers.get('x-auth-token')
                    if (response.status === 401) { sessionStorage.clear(); updateConnect(false) }
                    else {
                        if (token && token !== sessionStorage.getItem('token') && token !== '') sessionStorage.setItem('token', token)
                        if (response.status === 200) {
                            const comptes = await response.json()
                            setBudgetComplete(comptes.reduce((tt, cpt) => tt + cpt.percent, 0) >= 100)
                        }
                    }
                })

            const query = new URLSearchParams({exercice: exercice, eglise: eglise.number, isMonth: true})
            fetch(API.concat(`/clotures/by?${query.toString()}`),{
                method: 'GET',
                headers
            }).then(async response => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const clotures = await response.json()
                        const allMonths = Array.from({ length: exercice===new Date().getFullYear() ? new Date().getMonth() + 1 : 12 }, (_, i) => i)
                        const cloturedMonths = clotures.map(cloture=> new Date(cloture.date).getMonth())
                        const uncloturedMonths = allMonths.filter(month=> !cloturedMonths.includes(month))
                        setUncloture_months(uncloturedMonths)
                    } setLoad(false)
                }
            })

            // Fetch all clotures (all years) for the side panel
            const allQuery = new URLSearchParams({eglise: eglise.number, isMonth: true})
            fetch(API.concat(`/clotures/by?${allQuery.toString()}`), { method: 'GET', headers })
                .then(async response => {
                    const token = response.headers.get('x-auth-token')
                    if (token && token !== sessionStorage.getItem('token') && token !== '') sessionStorage.setItem('token', token)
                    if (response.status === 200) {
                        const clotures = await response.json()
                        const byYear = {}
                        clotures.forEach(cl => {
                            const year = new Date(cl.date).getFullYear()
                            const m = new Date(cl.date).getMonth()
                            if (!byYear[year]) byYear[year] = []
                            if (!byYear[year].includes(m)) byYear[year].push(m)
                        })
                        Object.keys(byYear).forEach(y => byYear[y].sort((a, b) => a - b))
                        setCloturesByYear(byYear)
                    }
                })
        }
    }, [eglise])

    useEffect(()=>{
        if (organisation&&organisation.type==='fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:{type:'église'})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[])

    const sortedYears = Object.keys(cloturesByYear).map(Number).sort((a, b) => b - a)

    return(
        <div style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Clôture</Typography>
            {organisation&&organisation.type==='fédération'&&<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(old=>{if(old!==e.target.value)reset(); return e.target.value})}>
                {eglises.map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}

            <Box sx={{display:'flex', flexDirection:'row', gap:2, paddingX:'20px', marginTop:'10px'}}>

                {/* Contenu principal */}
                <Box sx={{flex:1}}>
                    {eglise&&<Box sx={{marginTop:'20px'}}>
                        <TextField
                        select
                        sx={{minWidth:'300px', marginBottom:'25px'}}
                        required
                        label="Mois a clôturer"
                        value={month}
                        onChange={(e)=> {
                            setMonth(Number(e.target.value))
                            get_uncloture(Number(e.target.value))
                        }}
                        >
                        {uncloture_months.length<=0 ? <MenuItem value="">Aucun mois disponible</MenuItem>
                        :uncloture_months.map((month, index) => (
                            <MenuItem key={index} value={month}>
                                <Typography>{months[month]}</Typography>
                            </MenuItem>
                        ))}
                        </TextField>

                        {month !=='' && <div style={{display:'flex', justifyContent:'center'}}><Paper sx={{ height:'100%', paddingX:'25px', paddingY:'30px'}}>
                            <Typography variant="h5" sx={{marginBottom:'15px'}}><span style={{fontWeight:'bold'}}>{dons.length}</span> don{dons.length>1 && 's'} d'une recette local totale de
                            <span style={{fontWeight:'bold'}}> {(dons.reduce((accumulator, currentValue) => {
                                    const toadd = currentValue.offrande_spe_eglise.reduce((off_accumulator, off_currentValue)=>{return off_accumulator + off_currentValue.montant}, 0)
                                    return accumulator + currentValue.offrande_globale*0.6 + (toadd?? 0)}, 0)).toFixed(2)}€</span>
                            </Typography>
                            <Typography variant="h5" sx={{marginBottom:'15px'}}><span style={{fontWeight:'bold'}}>{versements.length}</span> versement{versements.length>1 && 's'}</Typography>
                            <Typography variant="h5" sx={{marginBottom:'15px'}}><span style={{fontWeight:'bold'}}>{depenses.length}</span> dépense{depenses.length>1 && 's'} d'un total de
                                <span style={{fontWeight:'bold'}}> {(depenses.reduce((accumulator, currentValue) => {return accumulator + currentValue.montant}, 0)).toFixed(2)}€</span>
                            </Typography>
                        </Paper></div>}
                    </Box>}
                </Box>

                {/* Bandeau latéral — mois clôturés */}
                {sortedYears.length > 0 && (
                    <Paper elevation={2} sx={{width:300, minWidth:300, alignSelf:'flex-start', padding:1}}>
                        <Typography variant='subtitle1' sx={{fontWeight:'bold', textAlign:'center', paddingY:1}}>
                            Mois clôturés
                        </Typography>
                        {sortedYears.map(year => (
                            <Accordion
                                key={year}
                                defaultExpanded={year === new Date().getFullYear()}
                                disableGutters
                                elevation={0}
                                sx={{'&:before':{display:'none'}}}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon/>} sx={{minHeight:40, '& .MuiAccordionSummary-content':{margin:'6px 0'}}}>
                                    <Typography fontWeight='bold'>{year}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{padding:'0 12px 12px'}}>
                                    <List dense disablePadding>
                                        {cloturesByYear[year].map(m => (
                                            <ListItem key={m} disablePadding sx={{paddingY:'4px'}}>
                                                <CheckCircleOutlineIcon sx={{fontSize:16, color:'success.main', mr:1}}/>
                                                <ListItemText primary={months[m]} primaryTypographyProps={{variant:'body1'}}/>
                                            </ListItem>
                                        ))}
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Paper>
                )}
            </Box>

            {/* Messages d'erreur et bouton — sous le layout principal */}
            <Box rowGap={1} sx={{display:'flex', flexDirection:'column', marginTop:'20px', paddingX:'20px'}}>
                {new Date().getMonth() === month && new Date().getFullYear() === exercice ? <Typography variant="subtitle1" textAlign='center' sx={{color: 'carmine.main', marginTop:versements.some(verse=>verse.is_error)?0:'20px', alignSelf:'flex-end', marginRight:'15px'}}>
                    Vous ne pouvez pas clôturer un mois en cours.
                </Typography>
                :<>
                {!isBudgetComplete&&<Typography variant="subtitle1" textAlign='center' sx={{color: 'carmine.main', alignSelf:'flex-end', marginRight:'15px'}}>
                    La répartition budgétaire est incomplète (total &lt; 100%).<br/>Veuillez compléter la répartition dans la gestion des comptes avant de clôturer.
                </Typography>}
                {versements.some(verse=>verse.is_error)&&<Typography variant="subtitle1" textAlign='center' sx={{color: 'carmine.main', alignSelf:'flex-end', marginRight:'15px'}}>
                    Vous avez un ou plusieurs versements en erreur.<br/>Veuillez contacter votre Administrateur.
                </Typography>}
                {month!=="" && dons.some(don=> !don.is_verse && new Date(don.date).getMonth()===month) &&
                <Typography variant="subtitle1" textAlign='center' sx={{color: 'carmine.main', marginTop:versements.some(verse=>verse.is_error)?0:'20px', alignSelf:'flex-end', marginRight:'15px'}}>
                    <span style={{fontWeight:'bold'}}>Attention!</span><br/>Il vous reste des dons à verser pour le mois de {months[month]}.<br/> Veuillez régulariser votre situation afin de clôturer le mois.
                </Typography>}
                </>
                }
                {month !== '' && <Button
                    variant="contained"
                    sx={{ alignSelf:'flex-end', marginRight:'30px' }}
                    disabled={month===""|| dons.some(don=> !don.is_verse) || depenses.some(dep=> dep.to_controlle) || (new Date().getMonth() === month && new Date().getFullYear() === exercice) || versements.some(verse=>verse.is_error) || alerts.some(a=>a.level>=2) || !isBudgetComplete}
                    onClick={handleSubmit}>Cloturer le mois</Button>
                }
            </Box>

            <Backdrop open={loading}>{result??<CircularProgress color="inherit" />}</Backdrop>
        </div>
    )
}
